import { render, staticRenderFns } from "./TransferPage.vue?vue&type=template&id=28ca071f&scoped=true&"
import script from "./TransferPage.vue?vue&type=script&lang=js&"
export * from "./TransferPage.vue?vue&type=script&lang=js&"
import style0 from "./TransferPage.vue?vue&type=style&index=0&id=28ca071f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ca071f",
  null
  
)

export default component.exports